export class GetStreamCursorHaltsResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "haltedPartitions",
            "baseName": "haltedPartitions",
            "type": "Array<StreamCursorHalt>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GetStreamCursorHaltsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
